import {
	NEW_NOTIFICATION, REMOVE_NOTIFICATION
} from '../actions/notifications';

import type {
	Notification,
	NotificationsState,
} from '../types/notifications';

export type {
	Notification,
	NotificationsState,
} from '../types/notifications';

interface Action {
	type: string;
	payload: any;
}

export const NOTIFICATION_STYLES = {
	NORMAL: 0,
	TIMED: 1
}

export const initialState: NotificationsState = {
	notification: null
}

const actions: Map<any, Function> = new Map([
	[NEW_NOTIFICATION, (state: NotificationsState, action: Action) => ({ ...state, notification: action.payload })],
	[REMOVE_NOTIFICATION, (state: NotificationsState, action: Action) => ({ ...state, notification: null })]
]);

export function NotificationsReducer(state: NotificationsState = initialState, action: Action) {
	return actions.get(action.type)?.(state, action) || state;
}